import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link to="https://www.skyler.media/contact/@blank">Contact</Link>
        </li>
        <li>
          <Link to="https://privacy.3096.skyler.media/@blank">Privacy Policy</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;